import { createAsyncThunk } from '@reduxjs/toolkit';
import { ImageModel, ImageModelSchema } from 'shared';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetDeliveryServiceApiResponseSchema = z.object({
    data: z.object({
        documentId: z.string(),
        title: z.string(),
        description: z.any().optional().nullable(),
        image: z.object({
            url: z.string(),
        }).optional().nullable(),
    }),
});

type GetDeliveryServiceApiResponse
    = ApiResponse<z.infer<typeof GetDeliveryServiceApiResponseSchema>>;

type GetDeliveryServiceActionRequest = undefined

export const getDeliveryService = createAsyncThunk<
    GetDeliveryServiceApiResponse | BaseError,
    GetDeliveryServiceActionRequest
>(
    'DeliveryPageActionsGetDeliveryService',
    async () => apiInstance.get(
        '/delivery-service',
        {
            'populate[image][fields]': 'url',
        },
        GetDeliveryServiceApiResponseSchema,
    ),
);

export const GetDeliveryServiceActionResponseMapper = {
    getImage: (
        { data }: GetDeliveryServiceApiResponse,
    ): ImageModel => ImageModelSchema.parse({
        url: data.data.image?.url,
    }),

    getTitle: (
        { data }: GetDeliveryServiceApiResponse,
    ): string => data.data.title,

    getDescription: (
        { data }: GetDeliveryServiceApiResponse,
    ): any => data.data.description,
};
